export default __webpack_public_path__ + "356e60ac27fb4d5dd834f6650ee468b3.png";